import { useEffect, useRef } from 'react';
import { updateDoc, DocumentReference } from 'firebase/firestore';

export const useRealtimeAutoSaver = <T extends Record<string, unknown>>(
    docRef: DocumentReference | null,
    data: T,
    delay = 800
) => {
    const latest = useRef(data);
    const serialized = JSON.stringify(data);

    useEffect(() => {
        latest.current = data;
    }, [serialized, data]);

    useEffect(() => {
        if (!docRef) return;
        const handle = setTimeout(() => {
            updateDoc(docRef, latest.current).catch((err) => {
                console.error('RealtimeAutoSaver failed:', err);
            });
        }, delay);
        return () => clearTimeout(handle);
    }, [docRef, serialized, delay]);
};
